import {
  ProviderSignInIntent,
  type ProviderSignInSearch,
} from "@/features/signin/provider-signin-search";

export type JobSignInSearch = ProviderSignInSearch & {
  redirect: string;
  intent: ProviderSignInIntent.Jobs;
};

export function buildJobSignInSearch({
  jobId,
  recruiterUserId,
  referralCode,
}: {
  jobId?: string;
  recruiterUserId?: string;
  referralCode?: string;
}): JobSignInSearch {
  let redirect = "/provider/jobs/recommended";
  if (jobId) {
    redirect = `/provider/jobs/${encodeURIComponent(jobId)}`;
    if (recruiterUserId) {
      redirect += `?${new URLSearchParams({ ref: recruiterUserId })}`;
    }
  }

  return { redirect, l: referralCode, intent: ProviderSignInIntent.Jobs };
}
